import { render } from "./map.vue?vue&type=template&id=55afa1e2"
import script from "./map.vue?vue&type=script&lang=js"
export * from "./map.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/resources/sellers/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__